import { type DocumentType, graphql } from '@generated/gql';

export const EDIT_ACCOUNT_ALLOCATIONS_FETCH_PORTFOLIO_REPORTS = graphql(
  /** GraphQL */ `
  query editAccountAllocationsFetchPortfolioReports($input: FetchPortfolioReportsInput!) {
    fetchPortfolioReports(input: $input) {
      portfolioReports {
        id
        allocationMethodology
        expectedCashPercentage
        modelPortfolio {
          strategy
        }
        holdings {
          expectedPercentage
          actualPercentage
          isCashEquivalent
          customExpectedPercentage
          assetClassPercentage
          assetClassGroupPercentage
          assetClass {
            id
            name
            translatedName {
              en
              fr
              es
            }
          }
          financialProduct {
            id
            ticker
            translatedName {
              en
              fr
              es
            }
            isCash
          }
        }
        subAccounts {
          id
          marketValueCents
          isTradeable
          subAccount {
            id
            state
            account {
              id
              custodianAccountNumber
              type
              user {
                firstName
                lastName
                entityName
              }
            }
          }
          holdings {
            expectedPercentage
            isCashEquivalent
            customExpectedPercentage
            assetClassPercentage
            assetClassGroupPercentage
            assetClass {
              id
              name
              translatedName {
                en
                fr
                es
              }
            }
            financialProduct {
              id
              ticker
              translatedName {
                en
                fr
                es
              }
              isCash
            }
          }
        }
      }
    }
  }
`,
);

export const EDIT_ACCOUNT_ALLOCATIONS_SET_ALLOCATION_METHODOLOGY = graphql(
  /** GraphQL */ `
  mutation editAccountAllocationsSetAllocationMethodology($input: SetAllocationMethodologyInput!) {
    setAllocationMethodology(input: $input) {
      portfolioReport {
        id
        allocationMethodology
      }
    }
  }
`,
);

export const EDIT_ACCOUNT_ALLOCATIONS_SET_CUSTOM_EXPECTED_PERCENTAGES = graphql(
  /** GraphQL */ `
  mutation editAccountAllocationsSetCustomExpectedPercentages($input: SetCustomExpectedPercentagesInput!) {
    setCustomExpectedPercentages(input: $input) {
      portfolioReport {
        id
      }
    }
  }
`,
);

export type EditAccountAllocationsPortfolioReport = DocumentType<
  typeof EDIT_ACCOUNT_ALLOCATIONS_FETCH_PORTFOLIO_REPORTS
>['fetchPortfolioReports']['portfolioReports'][number];
